import React from 'react';
import { Link, Image } from './common/NextAdapters';
import { Icon } from '@iconify/react';
import { useAuthStore } from '../store';
import { Button } from './ui/button';

const POINTS = [
  { icon: 'ph:devices', text: 'Watch on your phone, laptop, or TV' },
  { icon: 'ph:download-simple', text: 'Save titles to watch without data' },
  { icon: 'ph:arrow-u-up-left', text: 'Cancel any time from your account' },
];

export function SubscribeBand() {
  const isSubscribed = useAuthStore((s) => s.hasSubscription);

  if (isSubscribed) {
    return null;
  }

  return (
    <section className="relative overflow-hidden my-12">
      <Image
        src="/bg.png"
        alt=""
        fill
        sizes="100vw"
        className="object-cover"
      />
      <div className="absolute inset-0 bg-[#07050e]/85 backdrop-blur-[2px]" />
      <div
        aria-hidden
        className="absolute inset-0 opacity-25 mix-blend-screen brand-sweep"
      />
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#07050e] to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#07050e] to-transparent" />

      <div className="relative mx-auto max-w-[1600px] gutter py-16 sm:py-24">
        <div className="max-w-[36rem]">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white display leading-tight">
            One subscription, the whole catalogue
          </h2>
          <p className="mt-4 max-w-[48ch] text-sm sm:text-base leading-relaxed text-foreground/80">
            Films and series from across the continent and beyond, with new titles added every week.
          </p>

          <ul className="mt-6 space-y-3 list-none p-0">
            {POINTS.map((point) => (
              <li key={point.text} className="flex items-center gap-3 text-sm text-foreground/90">
                <Icon icon={point.icon} className="size-5 shrink-0 text-[#ff7a00]" />
                {point.text}
              </li>
            ))}
          </ul>

          <Button
            asChild
            size="lg"
            className="brand-sweep mt-8 h-12 rounded-full border-0 px-8 text-base font-semibold text-white shadow-xl hover:opacity-95"
          >
            <Link href="/subscribe">See plans & pricing</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}

export default SubscribeBand;
